import React from "react";
import styled from "styled-components";

// components
import { StyledText } from "./basic";
import { Box } from ".";

// svg

// hooks
import { useTheme } from "../../hooks/";

// lib

// theme
import theme from "../../theme";

const HumanCard = ({ duration, img, position, name, url, onPress }) => {
  const { themeContext } = useTheme();
  const { activeTheme } = themeContext;

  const bgColor =
    activeTheme === "midnight"
      ? theme.colors[themeContext.activeTheme].mashupBackground
      : "#F2F2F2";

  const activeColor = theme.colors[themeContext.activeTheme].background;

  return (
    <TouchableHighlight
      onClick={() => {
        onPress(url);
      }}
    >
      <Box
        themeAware={false}
        style={{
          display: "grid",
          alignItems: "space-around",
          borderRadius: 20,
          height: 200,
          width: "100%",
          backgroundColor: bgColor,
          shadowColor: activeTheme === "midnight" ? "black" : "#242424",
          shadowOpacity: activeTheme === "midnight" ? 1 : 0.23,
          boxShadow: "3px 3px 3px 2px #ccc",
          shadowRadius: 1.62,
          elevation: 4,
        }}
      >
        <FastImage
          style={{
            height: 85,
            width: 85,
            borderRadius: 45,
            margin: 10,
            justifySelf: "center",
          }}
          src={img}
        />

        <Box
          themeAware={false}
          style={{
            disaplay: "grid",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: bgColor,
            borderBottomLeftRadius: 20,
            borderBottomRightRadius: 20,
          }}
        >
          <Box
            themeAware={false}
            style={{
              alignSelf: "center",
              backgroundColor: "transparent",
              padding: 5,
            }}
          >
            <StyledText align={"center"} margin={0} fontFamily={500} size={14}>
              {name}
            </StyledText>
          </Box>
          <Box themeAware={false} backgroundColor={"transparent"}>
            <StyledText
              fontFamily={"medium"}
              size={12}
              margin={0}
              style={{ textAlign: "center", color: activeColor }}
            >
              {position}
            </StyledText>
            <StyledText
              margin={8}
              fontFamily={"medium"}
              size={10}
              style={{ textAlign: "center" }}
            >
              {duration}
            </StyledText>
          </Box>
        </Box>
      </Box>
    </TouchableHighlight>
  );
};

const TouchableHighlight = styled.div`
  height: 200px;
  width: 120px;
  margin-bottom: 20px;
`;

const FastImage = styled.img``;

export default HumanCard;
